	<div class="modal-header">
		<h4 class="modal-title">{{ 'FE.APPROVALS.MODALS.COMMON.TITLE' | localize }}</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalClose()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<p>{{message}}</p>
		<!--Reddetme metni - Burası sadece redetme işleminde gözükecektir.-->
		<textarea *ngIf="operationType == 0" [(ngModel)]="description" class="form-control" id="rejectTextarea" rows="3" placeholder="Talep reddetme nedenini yazın."></textarea>
		<!--Reddetme metni -->
	</div>
	<div class="modal-footer">
		<button *ngIf="operationType == 0" type="button" class="btn btn-danger" (click)="approvalOrRejectOperation()">{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.DELETEMODAL.BUTTON.REJECT' | localize }}</button>
		<button *ngIf="operationType == 1" type="button" class="btn btn-success" (click)="approvalOrRejectOperation()">{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.DELETEMODAL.BUTTON.APPROVE' | localize }}</button>
		<button *ngIf="operationType == 2" type="button" class="btn btn-danger" (click)="approvalOrRejectOperation()">{{ 'FE.APPROVALS.TABS.WAITINGFORAPPROVAL.DELETEMODAL.BUTTON.CANCEL' | localize }}</button>

		<button type="button" class="btn btn-light" (click)="modalClose()">{{ 'FE.MODALS.COMMON.BUTTON.CLOSE' | localize }}</button>
	</div>
